import { Box, useTheme } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface DateRangeFilterProps {
    onChange: (dates: { start: string | null; end: string | null }) => void;
    value?: { start?: string | null; end?: string | null };
}



const DateRangeFilter: React.FC<DateRangeFilterProps> = ({ onChange, value }) => {
    const { t } = useTranslation();
    const theme = useTheme();

    // Convert string dates to Date objects for the DatePicker
    const startDate = value?.start ? new Date(value.start) : null;
    const endDate = value?.end ? new Date(value.end) : null;

    const handleStartDateChange = (date: Date | null) => {
        onChange({
            start: date ? date.toISOString() : null,
            end: endDate ? endDate.toISOString() : null,
        });
    };

    const handleEndDateChange = (date: Date | null) => {
        onChange({
            start: startDate ? startDate.toISOString() : null,
            end: date ? date.toISOString() : null,
        });
    };

    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'row',
            gap: 1,
            alignItems: 'center'
        }}>
            <DatePicker
                label={t('transactions.filters.startDate')}
                value={startDate}
                onChange={handleStartDateChange}
                slotProps={{
                    textField: {
                        size: 'small',
                        sx: {
                            width: '160px',
                            '& .MuiInputBase-root': {
                                height: '40px',
                                borderRadius: 1
                            },
                            '& .MuiOutlinedInput-root': {
                                '&:hover .MuiOutlinedInput-notchedOutline': {
                                    borderColor: theme.palette.primary.main,
                                },
                                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                    borderColor: theme.palette.primary.main,
                                },
                            }
                        },
                    },


                    popper: {
                        sx: {
                            zIndex: 1300,
                            '& .MuiPickersPopper-paper': {
                                bgcolor: (theme) => theme.palette.background.paper,
                                color: (theme) => theme.palette.text.primary,
                                borderRadius: 2,
                                border: '1px solid',
                                borderColor: (theme) => theme.palette.divider,
                                boxShadow: (theme) => `0px 5px 15px ${theme.palette.mode === 'dark' ? 'rgba(0, 0, 0, 0.2)' : 'rgba(0, 0, 0, 0.1)'}`,
                                // Paper overlay removed
                            }
                        }
                    }
                }}
            />
            <DatePicker
                label={t('transactions.filters.endDate')}
                value={endDate}
                onChange={handleEndDateChange}
                slotProps={{
                    textField: {
                        size: 'small',
                        sx: {
                            width: '160px',
                            '& .MuiInputBase-root': {
                                height: '40px',
                                borderRadius: 1
                            },
                            '& .MuiOutlinedInput-root': {
                                '&:hover .MuiOutlinedInput-notchedOutline': {
                                    borderColor: theme.palette.primary.main,
                                },
                                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                    borderColor: theme.palette.primary.main,
                                },
                            }
                        },
                    },


                    popper: {
                        sx: {
                            zIndex: 1300,
                            '& .MuiPickersPopper-paper': {
                                bgcolor: (theme) => theme.palette.background.paper,
                                color: (theme) => theme.palette.text.primary,
                                borderRadius: 2,
                                border: '1px solid',
                                borderColor: (theme) => theme.palette.divider,
                                boxShadow: (theme) => `0px 5px 15px ${theme.palette.mode === 'dark' ? 'rgba(0, 0, 0, 0.2)' : 'rgba(0, 0, 0, 0.1)'}`,
                                // Paper overlay removed
                            }
                        }
                    }
                }}
                minDate={startDate || undefined}
            />
        </Box>
    );
};

export default DateRangeFilter;
